/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha3 = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M79.87 2H47.859C44.071 2 41 4.887 41 8.676V45h7.191c1.35-8 7.932-13.255 15.854-13.255S78.552 37 79.9 45H87V8.676C87 4.887 83.658 2 79.87 2z" />
    <path d="M77.912 48c-.777 0-1.516-.216-2.213-.225-.027-6.566-5.346-12.05-11.919-12.05-6.576 0-11.877 5.535-11.901 12.104-.528.007-1.085.171-1.661.171H41v72.141A6.86 6.86 0 0047.859 127H79.87c3.788 0 7.13-3.071 7.13-6.859V48h-9.088zm-13.946 6.119a6.716 6.716 0 110-13.432 6.716 6.716 0 010 13.432z" />
  </svg>
);
export default extendIcon(Deha3);
